import React from 'react';
import IafsTable from './IafsTable';

function SignalIafsTable({ iafs }) {
  return (
    <IafsTable
      title="Compensi da segnalazioni"
      iafs={iafs}
      anchorId="iafs-signals"
    />
  );
}

export default SignalIafsTable;
